import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'tiny-invariant';

function MessagesSelector(_ref) {
  var children = _ref.children,
      locale = _ref.locale,
      messages = _ref.messages;
  var MessagesComponent = React.useMemo(function () {
    invariant(messages[locale], "Cldr handle component for locale '".concat(locale, "' is not set in prop 'messages' of GlobalizeProvider") + " Prop 'messages' is an Object with `locale` as a Object key and `MessagesComponent` as a value");
    return messages[locale];
  }, [locale, messages]);
  return children(MessagesComponent);
}

MessagesSelector.propTypes = {
  children: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape({}).isRequired
};
MessagesSelector.defaultProps = {};
export default MessagesSelector;